/**
 * @generated SignedSource<<a123c18bdfb824d292ef5e984b951afb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteOfferFileInput = {
  clientMutationId?: string | null;
  ids: ReadonlyArray<string>;
};
export type offerFilesTable_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteOfferFileInput;
};
export type offerFilesTable_DeleteMutation$data = {
  readonly Admin: {
    readonly Offer: {
      readonly deleteOfferFile: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null;
    };
  };
};
export type offerFilesTable_DeleteMutation = {
  response: offerFilesTable_DeleteMutation$data;
  variables: offerFilesTable_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "offerFilesTable_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Offer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteOfferFilePayload",
                "kind": "LinkedField",
                "name": "deleteOfferFile",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "offerFilesTable_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Offer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteOfferFilePayload",
                "kind": "LinkedField",
                "name": "deleteOfferFile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b3a3a6aaee8b2a9f9e48f3656d1c87d9",
    "id": null,
    "metadata": {},
    "name": "offerFilesTable_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation offerFilesTable_DeleteMutation(\n  $input: DeleteOfferFileInput!\n) {\n  Admin {\n    Offer {\n      deleteOfferFile(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8dcac2e2a27ad873ceb7cfc71fd5860b";

export default node;
